$(document).ready(function() {
console.log('only product form');
	var checkFormInterval = setInterval(function() {

        var form = $('#product-registration').find('form'),
            loadingSpinner = $('<div class="spinner-con"><div class="loading-spinner"></div></div>'),
            newConsentError = $('<div class="custom-error">Please accept the terms and conditions to proceed.</div>');
        // Check if the form is found

        if (form.length > 0) {

            clearInterval(checkFormInterval); // Stop checking once the form is found
            // Now you can add event listeners, modify the form, or interact with 
            $(form).find('.btn-primary').text('Submit Registration');
            $('.mpr-input-serial-number').after(loadingSpinner);

            var replaceText = "Will you allow us to contact you regarding your registration? (we'll only use your data for this purpose only)",
                extraTC = $('.mpr-class-_extraTAndC').find('.mpr-custom-label').text(replaceText),
                serialInput = $('.mpr-input-serial-number').find('input'),
                consentTickbox = $('.checkbox-consent-row').find('.mpr-input-tickbox'),
                checkboxValidationError = $('.checkbox-consent-row').find('.mpr-validation-error'),
                consentBox = $('.checkbox-consent-row').find('input');


                $(consentTickbox).after(newConsentError);
                checkboxValidationError.hide(); 

                $(consentBox).on("change", function() {
                $(newConsentError).hide();
                });

			$(serialInput).on('blur', function() {
			    // Show the spinner
       		   $(loadingSpinner).css("display", "flex");
			    
			    // Introduce a 1 second delay before executing the rest of the code
			    setTimeout(function() {
			    	$(loadingSpinner).hide();
			        var entry = $('.mpr-serial-number-entry');
			        if (entry.length > 0) {  // Check if the element exists in the DOM
			            $(serialInput).hide();  // Hide the serial input field
			            var serialDelete = $('.mpr-input-serial-number').find('button');
			            // Add click event listener to the delete button
			            $(serialDelete).on("click", function() {
			                $(serialInput).show();  // Show the input again when delete is clicked
			            });

			        } else {
			            console.log('Entry does not exist');
			        }
			    }, 2000);  // Delay execution by 1 second (1000 milliseconds)
			});



            form.submit(function(event) {
			        if (!$(consentBox).is(':checked')) {
                        $(newConsentError).show();
			        } else {
			            console.log("Error message not found or not needed.");
			        } // Adjust this delay if needed based on how long the third-party validation takes
			});
        } else {
            console.log("Waiting for the form to load...");
        }
    }, 500); // Check every 500ms if the form is loaded

});